export default {
  agenda: {
    type: Object,
    required: true
  },
  dataCovenant: {
    type: Object,
    required: false
  },
  dataPatient: {
    type: Object,
    required: false
  },
  schedule: {
    type: Object,
    required: false
  },
  time: {
    type: Object,
    required: true
  },
  isPrivateSchedule: {
    type: Boolean,
    default: true
  }
}



// WEBPACK FOOTER //
// ./src/app/patient/agendas/form/resources/props.js